<script lang="ts">
    import Locales from './SettingsLocales.svelte';
    import SettingsServiceTime from './SettingsServiceTime.svelte';
    import SettingsMessageText from './SettingsMessageText.svelte';

    import { clientSettings, customerSettings } from '../../../stores/api';
    import { SettingsApi } from './SettingsApi';
    import { api } from '../../../stores/api';
    import {
        ClientSettingsSchema,
        defaultClientSettings,
        CustomerSettingsSchema,
    } from './settings';
    import SettingsApp from './SettingsApp.svelte';
    import SettingsRouteSendTime from './SettingsRouteSendTime.svelte';
    import SettingsDisplay from './SettingsDisplay.svelte';
    import SettingsAdmin from './SettingsAdmin.svelte';
    import { openModal } from 'svelte-modals';
    import ModalFeatures from '../../shared/Features/ModalFeatures.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { app } from '../../../stores/app';
    import SettingsAccount from './SettingsAccount.svelte';
    import { _ } from 'svelte-i18n';
    import SettingsCalculationDetails from './SettingsCalculationDetails.svelte';
    import SettingsAllowedArea from './SettingsAllowedArea.svelte';

    function updateCustomer() {
        try {
            CustomerSettingsSchema.parse($customerSettings);
            SettingsApi.setCustomerSettings($api, $customerSettings);
        } catch (e: any) {
            console.error('settings store error', e);
            alert('settings store error');
            throw new Error('settings store error');
        }
    }

    function updateClient() {
        try {
            try {
                ClientSettingsSchema.parse($clientSettings);
            } catch (e: any) {
                console.error('settings store error', e);
                $clientSettings = { ...defaultClientSettings };
                throw new Error('settings store error');
            }
            SettingsApi.setClientSettings($api, 'settings', $clientSettings, ClientSettingsSchema);
        } catch (e: any) {
            console.error('settings store error', e);
            alert('settings store error');
            throw new Error('settings store error');
        }
    }
</script>

<div style="margin-bottom: 50px;">
    {#if $app.isAdmin}
        <div style="width: 100%; display: flex; justify-content: flex-end">
            <ButtonMain
                text={$_('Features')}
                on:click={() => {
                    openModal(ModalFeatures, {});
                }}
            />
        </div>
    {/if}
    <Locales {updateClient} />
    <!--    <SettingsAccount />-->
    <SettingsCalculationDetails {updateCustomer} />
    <SettingsDisplay {updateClient} />
    <SettingsAllowedArea />

    <!--    <SettingsApp updateCustomer={updateCustomer} />-->
    <!--    <SettingsServiceTime updateCustomer={updateCustomer} />-->
    <!--    <SettingsMessageText updateCustomer={updateCustomer} />-->
    <!--    <SettingsRouteSendTime updateCustomer={updateCustomer} />-->
    <!--{#if $customerSettings.admin && $customerSettings.admin.show_data_reset_button}-->
    <!--    <SettingsAdmin {updateClient} />-->
    <!--{/if}-->
</div>
